module.exports = __webpack_public_path__ + "img/exam.dd05b1fb.jpg";